module.exports = __webpack_public_path__ + "img/logo3.1ed36df1.png";